// extracted by mini-css-extract-plugin
export default {"companyContainer":"eQ-z","companyImage":"fQ-z","container":"gQ-z","heading":"hQ-z","darkText":"iQ-z","smallHeading":"jQ-z","darkBackground":"kQ-z","whiteBackground":"lQ-z"};